<template>
	<div>

		<!-- Channels Search -->
		<v-row>
			<v-col cols="8" sm="6" md="4">

				<v-text-field
						v-model="searchChannels"
						append-icon="mdi-magnify"
						class="rounded-lg"
						clearable
						dense
						hide-details
						label="Search"
						outlined
				></v-text-field>

			</v-col>
      <v-col cols="4" md="3">
        <div class="form-check form-check-inline">
          <input
              v-model="showDeleted"
              class="form-check-input"
              type="checkbox"
              :value="1"
              false-value=""
          />
          <label class="form-check-label"
          >Archived</label
          >
        </div>
      </v-col>
		</v-row>
		<!-- Channels Search - END -->

		<bw-table
				aria-label="data-table"
				:headers="headers"
        hide-search
				:items="filteredChannels"
				:search="searchChannels"
		>
			<template v-slot:item.name="{ item: channel }">
				<div
						class="font-weight-bold text-subtitle-2 primary--text text--darken-4"
						style="flex-wrap: nowrap !important;"
				>
					{{ channel.name }} {{channel.deleted ? '(Archived)' : ''}}
				</div>
			</template>
			<template v-slot:item.actions="{ item: channel }">
				<div class="d-flex">
					<v-btn
              class="me-2 me-md-4 ml-auto"
							color="secondary"
							depressed
							fab
							outlined
							small
							@click="viewChannel(channel)"
					>
						<v-icon small>mdi-eye-outline</v-icon>
					</v-btn>
          <v-btn
              v-if="!channel.deleted"
              color="error"
              depressed
              fab
              @click="showConfirmRemoveDialog(channel)"
              outlined
              small
          >
            <v-icon>
              mdi-trash-can-outline
            </v-icon>
          </v-btn>
          <v-btn
              v-else
              color="secondary"
              depressed
              fab
              @click="showConfirmRecoverDialog(channel)"
              outlined
              small
          >
            <v-icon>
              mdi-undo-variant
            </v-icon>
          </v-btn>
				</div>
			</template>
		</bw-table>
    <confirm-dialog
        :description="(itemToUpdate && itemToUpdate.deleted == 1) ? 'Please click \'Confirm\' to archive this item. You will be able to recover this item by filtering by \'Archived\' in the future.' : 'Are your sure?'"
        :open="!!itemToUpdate"
        :title="confirmDialogTitle"
        @cancel="() => itemToUpdate = null"
        @confirm="() => itemToUpdate.deleted == 1 ? doRemove() : doRecover()"
    ></confirm-dialog>
	</div>
</template>

<script>
import ConfirmDialog from "../../../../Shared/UI/ConfirmDialog.vue";

export default {
	name: 'ListChannels',
  components: {ConfirmDialog},
	props: {
		channelsData: {
			type: Array,
			default: () => []
		},
		partner: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			// From here or passed from blade file to props
      confirmDialogTitle: '',
      displayFilters: {
        archived: {
          name: 'Archived',
          type: 'checkbox',
          default: false,
          position: 'main',
          filterOnFalse: 'deleted',
        },
      },
			headers: [
				{
					align: 'start',
					mandatory: true,
					text: 'Channel',
					value: 'name',
					width: '90%'
				},
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Actions',
					value: 'actions',
					width: '1%'
				}
			],
			channels: this.channelsData,
      itemToUpdate: null,
			searchChannels: '',
      showDeleted: false,
		};
	},
  computed: {
    filteredChannels() {
      return this.channels.filter(channel => {
        if (this.showDeleted) {
          return true;
        }
        return !channel.deleted;
      });
    }
  },
	methods: {
		viewChannel(channel) {
			window.location.href = `/partner-portal/${ this.partner.id }/channels/${ channel.id }/items`;
		},

    doRemove() {
      this.saveChanges('Channel removed.');
    },
    doRecover() {
        this.saveChanges('Channel recovered.');
    },
    async refreshChannels() {
      try {
        const { data } = await axios.get(`/partner-portal/${this.partner.id}/channels/list`);
        this.channels = data.allChannels;
      }
      catch (error) {
        window.EventBus.$emit('system-messages', [
          { message: error.message, messageType: 'error' }
        ]);
      }
    },

    showConfirmRemoveDialog(item) {
        this.confirmDialogTitle = 'Remove Channel';
        this.itemToUpdate = {id: item.id, type: item.type, deleted: 1};
    }, 
        showConfirmRecoverDialog(item) {
        this.confirmDialogTitle = 'Recover Channel';
        this.itemToUpdate = {id: item.id, type: item.type, deleted: 0};
    },
    async saveChanges(actionMessage) {
      const channel = this.itemToUpdate;
      this.isSaving = true;
      const url = `/partner-portal/${this.partner.id}/channels/save-channel/${channel.id}`;

      try {
        const { data } = await axios.put(url,channel);
        this.itemToUpdate = null;
        const message = `${actionMessage} Retrieving channels list...`;
        window.EventBus.$emit('system-messages', [
          {
            message,
            messageType: 'success',
            showOverlay: true
          }
        ]);
        await this.refreshChannels();
      }
      catch (error) {
        this.isSaving = false;
        window.EventBus.$emit('system-messages', [
          { message: error.message, messageType: 'error' }
        ]);
      }
    },
	}
};
</script>

<style lang="scss" scoped></style>
